/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Similar: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="similar" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M226.6666666666667 283.3333333333335H1020C1020 221 969 170 906.6666666666666 170H113.3333333333333V850C113.3333333333333 912.3333333333331 164.3333333333333 963.3333333333334 226.6666666666667 963.3333333333334V283.3333333333335zM963.3333333333331 793.3333333333334L680 623.3333333333334V963.3333333333334L963.3333333333331 793.3333333333334zM1133.3333333333333 1190C1195.6666666666667 1190 1246.6666666666665 1139 1246.6666666666665 1076.6666666666667V510C1246.6666666666665 447.6666666666667 1195.6666666666667 396.6666666666668 1133.3333333333333 396.6666666666668H340V1076.6666666666667C340 1139 391 1190 453.3333333333333 1190H1133.3333333333333zM453.3333333333333 510H1133.3333333333333V1076.6666666666667H453.3333333333333V510z" : "M181.3333333333334 226.6666666666667H816C816 176.7999999999999 775.2000000000002 136 725.3333333333334 136H90.6666666666667V680C90.6666666666667 729.8666666666666 131.4666666666667 770.6666666666666 181.3333333333334 770.6666666666666V226.6666666666667zM770.6666666666667 634.6666666666666L544 498.6666666666666V770.6666666666666L770.6666666666667 634.6666666666666zM906.6666666666669 952C956.5333333333334 952 997.3333333333334 911.2 997.3333333333334 861.3333333333333V408C997.3333333333334 358.1333333333332 956.5333333333334 317.3333333333333 906.6666666666669 317.3333333333333H272V861.3333333333333C272 911.2 312.8 952 362.6666666666667 952H906.6666666666669zM362.6666666666667 408H906.6666666666669V861.3333333333333H362.6666666666667V408z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Similar.displayName = `Blueprint5.Icon.Similar`;
export default Similar;
